export const bankTranslations = {
  ru: {
    'bank.scopeError.noLocation': 'Не выбрана точка для загрузки. Обновите страницу или выберите точку.',
    'bank.upload.error.primary': 'Не удалось загрузить файл',
    'bank.upload.error.emptyFile': 'В загруженном файле нет данных для импорта.',
    'bank.upload.error.generic': 'Файл не удалось обработать. Проверьте, что он выгружен из поддерживаемого банка и сохранён без изменений.',
    'bank.filter.status': 'Статус: {status}',
    'bank.filter.qualityWarnings': 'Качество: предупреждения',
    'bank.filter.qualityNeedsReview': 'Качество: требуют проверки',
    'bank.filter.qualityUnsupported': 'Качество: неподдерживаемый формат',
    'bank.filter.duplicates': 'Возможные дубли',
    'bank.location.label': 'Точка:',
    'bank.upload.dropzone.pending': 'Загружаем файл…',
    'bank.upload.dropzone.active': 'Отпустите файл для загрузки',
    'bank.upload.dropzone.idle': 'Перетащите файл сюда или нажмите «Выбрать файл»',
    'bank.upload.dropzone.formats': 'CSV, Excel, TXT, PDF — формат определится на сервере',
    'bank.upload.chooseFile': 'Выбрать файл',
    'bank.upload.whatToCheck': 'Что проверить: {text}',
    'bank.upload.nextAction': 'Что сделать дальше: {text}',
    'bank.upload.openImport': 'Открыть импорт',
    'bank.upload.qualityReport': 'Перейти к Quality report',
    'bank.upload.supportedBanksLink': 'Поддерживаемые банки и форматы',
    'bank.upload.tryAnotherFile': 'Попробовать загрузить другой файл',
    'bank.supportedBanks.title': 'Поддерживаемые банки и форматы',
    'bank.page.list.title': 'Импорты выписок',
    'bank.page.upload.title': 'Загрузка банковской выписки',
    'bank.page.upload.subtitle': 'Загрузите файл — система определит банк и распознает транзакции',
    'bank.error.loadImports': 'Не удалось загрузить список импортов',
    'bank.table.file': 'Файл',
    'bank.table.bank': 'Банк',
    'bank.table.format': 'Формат',
    'bank.table.quality': 'Качество',
    'bank.table.detection': 'Распознавание',
    'bank.table.parse': 'Парсинг',
    'bank.table.transactions': 'Транзакций',
    'bank.table.warningsShort': 'Предупр.',
    'bank.table.duplicates': 'Дубли',
    'bank.table.status': 'Статус',
    'bank.table.imported': 'Импорт',
    'bank.empty.imports.title': 'Импортов пока нет',
    'bank.empty.imports.description': 'Загрузите первую банковскую выписку, чтобы начать обработку.',
    'bank.detail.error.load': 'Не удалось загрузить импорт',
    'bank.detail.error.qualityReport': 'Отчёт качества недоступен',
    'bank.detail.defaultTitle': 'Импорт выписки',
    'bank.detail.defaultSubtitle': 'Распознанные транзакции и качество импорта',
    'bank.detail.summary.detection': 'Распознавание: {value}',
    'bank.detail.summary.parse': 'Парсинг: {value}',
    'bank.detail.summary.rows': 'Строк: {value}',
    'bank.detail.summary.warnings': 'Предупреждений: {value}',
    'bank.detail.summary.errors': 'Ошибок: {value}',
    'bank.recognition.status.pending': 'В очереди',
    'bank.recognition.status.processing': 'Читаем документ…',
    'bank.recognition.status.needsReview': 'Нужна проверка',
    'bank.recognition.status.confirmed': 'Подтверждено',
    'bank.recognition.status.rejected': 'Отклонено',
    'bank.recognition.status.failed': 'Ошибка',
    'bank.recognition.next.pending': 'Документ ожидает обработки. Можно оставить страницу открытой.',
    'bank.recognition.next.processing': 'Извлекаем операции из файла. Это может занять несколько минут.',
    'bank.recognition.next.needsReview': 'Сверьте найденные операции с оригиналом и исправьте неточности.',
    'bank.recognition.next.confirmed': 'Операции созданы и готовы к дальнейшей обработке.',
    'bank.recognition.next.rejected': 'Документ отклонён. Загрузите исправленный файл, если он всё ещё нужен.',
    'bank.recognition.next.failed': 'Повторите распознавание. Если ошибка сохранится, загрузите другой файл.',
    'bank.recognition.bank': 'Банк: {bank}',
    'bank.recognition.operations': 'Найдено операций: {count}',
    'bank.detail.group.operations': 'Операции',
    'bank.detail.group.problems': 'Проблемы',
    'bank.detail.group.document': 'Документ',
    'bank.detail.group.advanced': 'Advanced',
    'bank.detail.tab.recognition': 'Распознавание',
    'bank.detail.tab.transactions': 'Транзакции',
    'bank.detail.tab.quality': 'Quality report',
    'bank.detail.tab.duplicates': 'Дубли',
    'bank.detail.tab.history': 'История',
    'bank.detail.tab.metadata': 'Метаданные',
    'bank.detail.tab.reprocessPreview': 'Reprocess preview',
    'bank.detail.table.counterparty': 'Контрагент',
    'bank.detail.table.purpose': 'Назначение',
    'bank.detail.table.matching': 'Сопоставление',
    'bank.duplicate.currentOperation': 'Текущая операция',
    'bank.duplicate.existingImport': 'Ранее импортированная',
    'bank.duplicate.field.date': 'Дата: {value}',
    'bank.duplicate.field.amount': 'Сумма:',
    'bank.duplicate.field.direction': 'Направление: {value}',
    'bank.duplicate.field.bankReference': 'Банковская ссылка: {value}',
    'bank.duplicate.field.customerReference': 'Клиентская ссылка: {value}',
    'bank.duplicate.field.counterparty': 'Контрагент: {value}',
    'bank.duplicate.field.description': 'Описание: {value}',
    'bank.duplicate.field.import': 'Импорт:',
    'bank.duplicate.field.bank': 'Банк: {value}',
    'bank.duplicate.field.account': 'Счёт: {value}',
    'bank.duplicate.confirm': 'Подтвердить дубль',
    'bank.duplicate.dismiss': 'Не дубль',
    'bank.duplicates.title': 'Возможные дубли',
    'bank.duplicates.subtitle': 'Система нашла операции, похожие на уже импортированные. Подтвердите дубль, если это повторная загрузка той же операции, или отклоните, если это отдельная операция.',
    'bank.duplicates.empty.title': 'Дублей не найдено',
    'bank.duplicates.empty.description': 'По этому импорту не найдено похожих операций из предыдущих загрузок.',
    'bank.quality.title': 'Качество импорта',
    'bank.quality.subtitle': 'Показывает, можно ли доверять распознаванию файла перед matching и allocation.',
    'bank.quality.metric.bank': 'Банк',
    'bank.quality.metric.format': 'Формат',
    'bank.quality.metric.detectionConfidence': 'Detection confidence',
    'bank.quality.metric.parseConfidence': 'Parse confidence',
    'bank.quality.metric.rows': 'Строки',
    'bank.quality.metric.parsed': 'Распознано',
    'bank.quality.metric.skipped': 'Пропущено',
    'bank.quality.metric.duplicates': 'Дубли',
    'bank.quality.desc.rawQualityStatus': 'Raw quality status: {status}',
    'bank.quality.desc.detectionConfidence': 'Уверенность определения банка/формата',
    'bank.quality.desc.parseConfidence': 'Качество разбора строк файла',
    'bank.quality.desc.totalRows': 'Всего строк транзакций',
    'bank.quality.desc.parsedTransactions': 'Создано банковских транзакций',
    'bank.quality.desc.skippedRows': 'Строки не попали в импорт',
    'bank.quality.desc.duplicateCandidates': 'Возможные повторные импорты',
    'bank.quality.balance.title': 'Проверка баланса',
    'bank.quality.balance.subtitle': 'Используется, если банк передал opening/closing balance или running balance.',
    'bank.quality.balance.unavailable': 'Недоступно',
    'bank.quality.balance.matches': 'Баланс совпадает',
    'bank.quality.balance.mismatch': 'Баланс не совпадает',
    'bank.quality.balance.mismatchMessage': 'Есть расхождение по балансу (информация). Банковская выписка — источник истины; проведение не блокируется.',
    'bank.quality.balance.reviewRequired': 'Баланс выписки не сходится с пересчётом. Это информационное предупреждение — оплата в Syrve не блокируется.',
    'bank.quality.balance.confirmReview': 'Подтвердить проверку баланса',
    'bank.quality.balance.override': 'Override: {reason}',
    'bank.quality.balance.openingBalance': 'Opening balance',
    'bank.quality.balance.closingBalance': 'Closing balance',
    'bank.quality.balance.calculatedClosingBalance': 'Calculated closing balance',
    'bank.quality.table.indicator': 'Показатель',
    'bank.quality.table.value': 'Значение',
    'bank.quality.table.line': 'Строка',
    'bank.quality.table.type': 'Тип',
    'bank.quality.table.message': 'Сообщение',
    'bank.quality.table.whatToCheck': 'Что проверить',
    'bank.quality.table.nextAction': 'Что сделать',
    'bank.quality.warnings.title': 'Предупреждения',
    'bank.quality.warnings.subtitle': 'Импорт успешен. Ниже — что стоит глянуть глазами; это не ошибка, если транзакции выглядят верно.',
    'bank.quality.warnings.empty': 'Предупреждений нет',
    'bank.quality.issue.line': 'Строка файла {line}',
    'bank.quality.issue.snippetLabel': 'Текст в выписке',
    'bank.quality.issue.openTransaction': 'Открыть транзакцию',
    'bank.quality.issue.openTransactionHint': 'Откройте вкладку «Транзакции» — строка будет подсвечена.',
    'bank.quality.errors.title': 'Ошибки',
    'bank.quality.errors.subtitle': 'Ошибки означают, что часть строк не была распознана или импорт требует проверки.',
    'bank.quality.errors.empty': 'Ошибок нет',
    'bank.history.loading': 'Загружаем историю импорта…',
    'bank.history.error': 'Не удалось загрузить историю импорта',
    'bank.history.title': 'История импорта',
    'bank.history.subtitle': 'Ключевые события загрузки, распознавания и действий оператора по этой выписке.',
    'bank.history.empty.title': 'История пуста',
    'bank.history.empty.description': 'По этому импорту пока нет зарегистрированных событий.',
    'bank.history.table.datetime': 'Дата и время',
    'bank.history.table.user': 'Пользователь',
    'bank.history.table.action': 'Действие',
    'bank.history.table.result': 'Результат / сообщение',
    'bank.history.detail.file': 'Файл: {fileName}',
    'bank.history.detail.candidates': 'Кандидатов: {count}',
    'bank.history.detail.status': 'Статус: {status}',
    'bank.history.detail.transactions': 'Транзакций: {count}',
    'bank.reprocess.status.completed': 'Завершён',
    'bank.reprocess.status.failed': 'Ошибка',
    'bank.reprocess.status.fileUnavailable': 'Файл недоступен',
    'bank.reprocess.previewTitle': 'Preview от {date}',
    'bank.reprocess.previewSubtitle': 'Read-only сравнение текущего pipeline с сохранёнными транзакциями импорта.',
    'bank.reprocess.fileUnavailableMessage': 'Исходный файл выписки недоступен. Для повторной обработки загрузите файл через обычный import.',
    'bank.reprocess.metric.adapter': 'Адаптер',
    'bank.reprocess.metric.versions': 'Версии',
    'bank.reprocess.metric.confidence': 'Confidence',
    'bank.reprocess.metric.existingTransactions': 'Existing transactions',
    'bank.reprocess.metric.previewTransactions': 'Preview transactions',
    'bank.reprocess.metric.added': 'Added',
    'bank.reprocess.metric.removed': 'Removed',
    'bank.reprocess.metric.changed': 'Changed',
    'bank.reprocess.metric.unchanged': 'Unchanged',
    'bank.reprocess.metric.warnings': 'Warnings',
    'bank.reprocess.metric.errors': 'Errors',
    'bank.reprocess.parserHint': 'parser {parser} · normalizer {normalizer}',
    'bank.reprocess.parseHint': 'parse {value}',
    'bank.reprocess.tab.title': 'Reprocess preview',
    'bank.reprocess.tab.subtitle': 'Запускает read-only прогон текущего adapter pipeline по исходному файлу и сохраняет diff. Production-данные не изменяются.',
    'bank.reprocess.tab.runButton': 'Preview reprocess',
    'bank.reprocess.tab.error': 'Не удалось выполнить preview reprocess',
    'bank.reprocess.tab.empty.title': 'Preview ещё не запускался',
    'bank.reprocess.tab.empty.description': 'Нажмите «Preview reprocess», чтобы сравнить текущий pipeline с сохранёнными транзакциями.',
    'bank.reprocess.tab.loading': 'Загружаем preview…',
    'bank.modal.balanceOverride.title': 'Подтверждение проверки баланса',
    'bank.modal.balanceOverride.reason': 'Причина',
    'bank.modal.balanceOverride.placeholder': 'Например: сверил totals вручную',
    'bank.modal.deleteImport.title': 'Удалить импорт выписки',
    'bank.modal.deleteImport.description': 'Импорт, транзакции и сопоставления по этой выписке будут удалены безвозвратно. Правила сопоставления контрагентов сохранятся.',
    'bank.modal.deleteImport.reason': 'Причина',
    'bank.modal.deleteImport.placeholder': 'Например: ошибочный файл, нужен переимпорт',
    'bank.modal.deleteImport.confirm': 'Удалить импорт',
    'bank.detail.deleteImport': 'Удалить импорт',
    'bank.detail.deleteImport.error': 'Не удалось удалить импорт',
    'bank.adapters.loading': 'Загружаем каталог банковских адаптеров…',
    'bank.adapters.error.unavailable': 'Не удалось загрузить список поддерживаемых банков.',
    'bank.adapters.readonlyNotice': 'Адаптеры определены в коде и не редактируются из админки. Изменения требуют релиза приложения.',
    'bank.adapters.empty': 'Пока нет опубликованных банковских адаптеров.',
    'bank.adapters.table.bank': 'Банк',
    'bank.adapters.table.format': 'Формат',
    'bank.adapters.table.status': 'Статус',
    'bank.adapters.table.extensions': 'Расширения',
    'bank.adapters.table.capabilities': 'Возможности',
    'bank.adapters.table.adapter': 'Адаптер',
    'bank.adapters.table.confidence': 'Уверенность',
    'bank.adapters.table.examples': 'Примеры файлов',
    'bank.adapters.table.notes': 'Примечания',
    'bank.adapters.table.updated': 'Обновлено',
  },
  en: {
    'bank.scopeError.noLocation': 'No location selected for upload. Refresh the page or select a location.',
    'bank.upload.error.primary': 'Failed to upload file',
    'bank.upload.error.emptyFile': 'The uploaded file contains no data to import.',
    'bank.upload.error.generic': 'The file could not be processed. Make sure it was exported from a supported bank and saved without changes.',
    'bank.filter.status': 'Status: {status}',
    'bank.filter.qualityWarnings': 'Quality: warnings',
    'bank.filter.qualityNeedsReview': 'Quality: needs review',
    'bank.filter.qualityUnsupported': 'Quality: unsupported format',
    'bank.filter.duplicates': 'Possible duplicates',
    'bank.location.label': 'Location:',
    'bank.upload.dropzone.pending': 'Uploading file…',
    'bank.upload.dropzone.active': 'Drop the file to upload',
    'bank.upload.dropzone.idle': 'Drag a file here or click "Choose file"',
    'bank.upload.dropzone.formats': 'CSV, Excel, TXT, PDF — format is detected on the server',
    'bank.upload.chooseFile': 'Choose file',
    'bank.upload.whatToCheck': 'What to check: {text}',
    'bank.upload.nextAction': 'Next step: {text}',
    'bank.upload.openImport': 'Open import',
    'bank.upload.qualityReport': 'Go to quality report',
    'bank.upload.supportedBanksLink': 'Supported banks and formats',
    'bank.upload.tryAnotherFile': 'Try uploading another file',
    'bank.supportedBanks.title': 'Supported banks and formats',
    'bank.page.list.title': 'Statement imports',
    'bank.page.upload.title': 'Upload bank statement',
    'bank.page.upload.subtitle': 'Upload a file — the system will detect the bank and parse transactions',
    'bank.error.loadImports': 'Failed to load import list',
    'bank.table.file': 'File',
    'bank.table.bank': 'Bank',
    'bank.table.format': 'Format',
    'bank.table.quality': 'Quality',
    'bank.table.detection': 'Detection',
    'bank.table.parse': 'Parsing',
    'bank.table.transactions': 'Transactions',
    'bank.table.warningsShort': 'Warn.',
    'bank.table.duplicates': 'Duplicates',
    'bank.table.status': 'Status',
    'bank.table.imported': 'Imported',
    'bank.empty.imports.title': 'No imports yet',
    'bank.empty.imports.description': 'Upload your first bank statement to start processing.',
    'bank.detail.error.load': 'Failed to load import',
    'bank.detail.error.qualityReport': 'Quality report unavailable',
    'bank.detail.defaultTitle': 'Statement import',
    'bank.detail.defaultSubtitle': 'Parsed transactions and import quality',
    'bank.detail.summary.detection': 'Detection: {value}',
    'bank.detail.summary.parse': 'Parsing: {value}',
    'bank.detail.summary.rows': 'Rows: {value}',
    'bank.detail.summary.warnings': 'Warnings: {value}',
    'bank.detail.summary.errors': 'Errors: {value}',
    'bank.recognition.status.pending': 'Queued',
    'bank.recognition.status.processing': 'Reading document…',
    'bank.recognition.status.needsReview': 'Review required',
    'bank.recognition.status.confirmed': 'Confirmed',
    'bank.recognition.status.rejected': 'Rejected',
    'bank.recognition.status.failed': 'Error',
    'bank.recognition.next.pending': 'The document is waiting to be processed. You can leave this page open.',
    'bank.recognition.next.processing': 'Extracting transactions from the file. This may take a few minutes.',
    'bank.recognition.next.needsReview': 'Compare the detected transactions with the original and correct any errors.',
    'bank.recognition.next.confirmed': 'Transactions have been created and are ready for further processing.',
    'bank.recognition.next.rejected': 'The document was rejected. Upload a corrected file if it is still needed.',
    'bank.recognition.next.failed': 'Retry recognition. If it fails again, upload another file.',
    'bank.recognition.bank': 'Bank: {bank}',
    'bank.recognition.operations': 'Transactions found: {count}',
    'bank.detail.group.operations': 'Operations',
    'bank.detail.group.problems': 'Problems',
    'bank.detail.group.document': 'Document',
    'bank.detail.group.advanced': 'Advanced',
    'bank.detail.tab.recognition': 'Recognition',
    'bank.detail.tab.transactions': 'Transactions',
    'bank.detail.tab.quality': 'Quality report',
    'bank.detail.tab.duplicates': 'Duplicates',
    'bank.detail.tab.history': 'History',
    'bank.detail.tab.metadata': 'Metadata',
    'bank.detail.tab.reprocessPreview': 'Reprocess preview',
    'bank.detail.table.counterparty': 'Counterparty',
    'bank.detail.table.purpose': 'Purpose',
    'bank.detail.table.matching': 'Matching',
    'bank.duplicate.currentOperation': 'Current transaction',
    'bank.duplicate.existingImport': 'Previously imported',
    'bank.duplicate.field.date': 'Date: {value}',
    'bank.duplicate.field.amount': 'Amount:',
    'bank.duplicate.field.direction': 'Direction: {value}',
    'bank.duplicate.field.bankReference': 'Bank reference: {value}',
    'bank.duplicate.field.customerReference': 'Customer reference: {value}',
    'bank.duplicate.field.counterparty': 'Counterparty: {value}',
    'bank.duplicate.field.description': 'Description: {value}',
    'bank.duplicate.field.import': 'Import:',
    'bank.duplicate.field.bank': 'Bank: {value}',
    'bank.duplicate.field.account': 'Account: {value}',
    'bank.duplicate.confirm': 'Confirm duplicate',
    'bank.duplicate.dismiss': 'Not a duplicate',
    'bank.duplicates.title': 'Possible duplicates',
    'bank.duplicates.subtitle': 'The system found transactions similar to ones already imported. Confirm a duplicate if this is a repeat upload of the same transaction, or dismiss if it is a separate transaction.',
    'bank.duplicates.empty.title': 'No duplicates found',
    'bank.duplicates.empty.description': 'No similar transactions from previous uploads were found for this import.',
    'bank.quality.title': 'Import quality',
    'bank.quality.subtitle': 'Shows whether file recognition can be trusted before matching and allocation.',
    'bank.quality.metric.bank': 'Bank',
    'bank.quality.metric.format': 'Format',
    'bank.quality.metric.detectionConfidence': 'Detection confidence',
    'bank.quality.metric.parseConfidence': 'Parse confidence',
    'bank.quality.metric.rows': 'Rows',
    'bank.quality.metric.parsed': 'Parsed',
    'bank.quality.metric.skipped': 'Skipped',
    'bank.quality.metric.duplicates': 'Duplicates',
    'bank.quality.desc.rawQualityStatus': 'Raw quality status: {status}',
    'bank.quality.desc.detectionConfidence': 'Confidence in bank/format detection',
    'bank.quality.desc.parseConfidence': 'Quality of file row parsing',
    'bank.quality.desc.totalRows': 'Total transaction rows',
    'bank.quality.desc.parsedTransactions': 'Bank transactions created',
    'bank.quality.desc.skippedRows': 'Rows not included in import',
    'bank.quality.desc.duplicateCandidates': 'Possible repeat imports',
    'bank.quality.balance.title': 'Balance check',
    'bank.quality.balance.subtitle': 'Used when the bank provided opening/closing balance or running balance.',
    'bank.quality.balance.unavailable': 'Unavailable',
    'bank.quality.balance.matches': 'Balance matches',
    'bank.quality.balance.mismatch': 'Balance mismatch',
    'bank.quality.balance.mismatchMessage': 'Balance discrepancy (informational). The bank statement is the source of truth; posting is not blocked.',
    'bank.quality.balance.reviewRequired': 'Statement balance does not match the recalculation. Informational only — posting to Syrve is not blocked.',
    'bank.quality.balance.confirmReview': 'Confirm balance review',
    'bank.quality.balance.override': 'Override: {reason}',
    'bank.quality.balance.openingBalance': 'Opening balance',
    'bank.quality.balance.closingBalance': 'Closing balance',
    'bank.quality.balance.calculatedClosingBalance': 'Calculated closing balance',
    'bank.quality.table.indicator': 'Metric',
    'bank.quality.table.value': 'Value',
    'bank.quality.table.line': 'Line',
    'bank.quality.table.type': 'Type',
    'bank.quality.table.message': 'Message',
    'bank.quality.table.whatToCheck': 'What to check',
    'bank.quality.table.nextAction': 'Next action',
    'bank.quality.warnings.title': 'Warnings',
    'bank.quality.warnings.subtitle': 'Import succeeded. Review the items below — not an error if transactions look correct.',
    'bank.quality.warnings.empty': 'No warnings',
    'bank.quality.issue.line': 'File line {line}',
    'bank.quality.issue.snippetLabel': 'Text in statement',
    'bank.quality.issue.openTransaction': 'Open transaction',
    'bank.quality.issue.openTransactionHint': 'Open the Transactions tab to locate this row.',
    'bank.quality.errors.title': 'Errors',
    'bank.quality.errors.subtitle': 'Errors mean some rows were not recognized or the import needs review.',
    'bank.quality.errors.empty': 'No errors',
    'bank.history.loading': 'Loading import history…',
    'bank.history.error': 'Failed to load import history',
    'bank.history.title': 'Import history',
    'bank.history.subtitle': 'Key upload, detection, and operator action events for this statement.',
    'bank.history.empty.title': 'History is empty',
    'bank.history.empty.description': 'No registered events for this import yet.',
    'bank.history.table.datetime': 'Date and time',
    'bank.history.table.user': 'User',
    'bank.history.table.action': 'Action',
    'bank.history.table.result': 'Result / message',
    'bank.history.detail.file': 'File: {fileName}',
    'bank.history.detail.candidates': 'Candidates: {count}',
    'bank.history.detail.status': 'Status: {status}',
    'bank.history.detail.transactions': 'Transactions: {count}',
    'bank.reprocess.status.completed': 'Completed',
    'bank.reprocess.status.failed': 'Failed',
    'bank.reprocess.status.fileUnavailable': 'File unavailable',
    'bank.reprocess.previewTitle': 'Preview from {date}',
    'bank.reprocess.previewSubtitle': 'Read-only comparison of the current pipeline with saved import transactions.',
    'bank.reprocess.fileUnavailableMessage': 'The original statement file is unavailable. Upload the file again via a regular import to reprocess.',
    'bank.reprocess.metric.adapter': 'Adapter',
    'bank.reprocess.metric.versions': 'Versions',
    'bank.reprocess.metric.confidence': 'Confidence',
    'bank.reprocess.metric.existingTransactions': 'Existing transactions',
    'bank.reprocess.metric.previewTransactions': 'Preview transactions',
    'bank.reprocess.metric.added': 'Added',
    'bank.reprocess.metric.removed': 'Removed',
    'bank.reprocess.metric.changed': 'Changed',
    'bank.reprocess.metric.unchanged': 'Unchanged',
    'bank.reprocess.metric.warnings': 'Warnings',
    'bank.reprocess.metric.errors': 'Errors',
    'bank.reprocess.parserHint': 'parser {parser} · normalizer {normalizer}',
    'bank.reprocess.parseHint': 'parse {value}',
    'bank.reprocess.tab.title': 'Reprocess preview',
    'bank.reprocess.tab.subtitle': 'Runs a read-only pass of the current adapter pipeline on the original file and stores the diff. Production data is not changed.',
    'bank.reprocess.tab.runButton': 'Preview reprocess',
    'bank.reprocess.tab.error': 'Failed to run reprocess preview',
    'bank.reprocess.tab.empty.title': 'Preview has not been run yet',
    'bank.reprocess.tab.empty.description': 'Click "Preview reprocess" to compare the current pipeline with saved transactions.',
    'bank.reprocess.tab.loading': 'Loading preview…',
    'bank.modal.balanceOverride.title': 'Confirm balance review',
    'bank.modal.balanceOverride.reason': 'Reason',
    'bank.modal.balanceOverride.placeholder': 'For example: verified totals manually',
    'bank.modal.deleteImport.title': 'Delete bank statement import',
    'bank.modal.deleteImport.description': 'The import, its transactions, and counterparty matches for this statement will be permanently removed. Counterparty matching rules will be kept.',
    'bank.modal.deleteImport.reason': 'Reason',
    'bank.modal.deleteImport.placeholder': 'For example: wrong file, need to re-import',
    'bank.modal.deleteImport.confirm': 'Delete import',
    'bank.detail.deleteImport': 'Delete import',
    'bank.detail.deleteImport.error': 'Failed to delete import',
    'bank.adapters.loading': 'Loading bank adapter catalog…',
    'bank.adapters.error.unavailable': 'Failed to load supported banks list.',
    'bank.adapters.readonlyNotice': 'Adapters are defined in code and cannot be edited from the admin UI. Changes require an application release.',
    'bank.adapters.empty': 'No published bank adapters yet.',
    'bank.adapters.table.bank': 'Bank',
    'bank.adapters.table.format': 'Format',
    'bank.adapters.table.status': 'Status',
    'bank.adapters.table.extensions': 'Extensions',
    'bank.adapters.table.capabilities': 'Capabilities',
    'bank.adapters.table.adapter': 'Adapter',
    'bank.adapters.table.confidence': 'Confidence',
    'bank.adapters.table.examples': 'Example files',
    'bank.adapters.table.notes': 'Notes',
    'bank.adapters.table.updated': 'Updated',
  },
  id: {
    'bank.scopeError.noLocation': 'Lokasi untuk unggahan belum dipilih. Muat ulang halaman atau pilih lokasi.',
    'bank.upload.error.primary': 'Gagal mengunggah file',
    'bank.upload.error.emptyFile': 'File yang diunggah tidak berisi data untuk diimpor.',
    'bank.upload.error.generic': 'File tidak dapat diproses. Pastikan file diekspor dari bank yang didukung dan disimpan tanpa perubahan.',
    'bank.filter.status': 'Status: {status}',
    'bank.filter.qualityWarnings': 'Kualitas: peringatan',
    'bank.filter.qualityNeedsReview': 'Kualitas: perlu ditinjau',
    'bank.filter.qualityUnsupported': 'Kualitas: format tidak didukung',
    'bank.filter.duplicates': 'Kemungkinan duplikat',
    'bank.location.label': 'Lokasi:',
    'bank.upload.dropzone.pending': 'Mengunggah file…',
    'bank.upload.dropzone.active': 'Lepaskan file untuk mengunggah',
    'bank.upload.dropzone.idle': 'Seret file ke sini atau klik "Pilih file"',
    'bank.upload.dropzone.formats': 'CSV, Excel, TXT, PDF — format dideteksi di server',
    'bank.upload.chooseFile': 'Pilih file',
    'bank.upload.whatToCheck': 'Yang perlu diperiksa: {text}',
    'bank.upload.nextAction': 'Langkah berikutnya: {text}',
    'bank.upload.openImport': 'Buka impor',
    'bank.upload.qualityReport': 'Ke laporan kualitas',
    'bank.upload.supportedBanksLink': 'Bank dan format yang didukung',
    'bank.upload.tryAnotherFile': 'Coba unggah file lain',
    'bank.supportedBanks.title': 'Bank dan format yang didukung',
    'bank.page.list.title': 'Impor rekening koran',
    'bank.page.upload.title': 'Unggah rekening koran',
    'bank.page.upload.subtitle': 'Unggah file — sistem akan mendeteksi bank dan mengenali transaksi',
    'bank.error.loadImports': 'Gagal memuat daftar impor',
    'bank.table.file': 'File',
    'bank.table.bank': 'Bank',
    'bank.table.format': 'Format',
    'bank.table.quality': 'Kualitas',
    'bank.table.detection': 'Deteksi',
    'bank.table.parse': 'Parsing',
    'bank.table.transactions': 'Transaksi',
    'bank.table.warningsShort': 'Pering.',
    'bank.table.duplicates': 'Duplikat',
    'bank.table.status': 'Status',
    'bank.table.imported': 'Diimpor',
    'bank.empty.imports.title': 'Belum ada impor',
    'bank.empty.imports.description': 'Unggah rekening koran pertama untuk memulai pemrosesan.',
    'bank.detail.error.load': 'Gagal memuat impor',
    'bank.detail.error.qualityReport': 'Laporan kualitas tidak tersedia',
    'bank.detail.defaultTitle': 'Impor rekening koran',
    'bank.detail.defaultSubtitle': 'Transaksi yang dikenali dan kualitas impor',
    'bank.detail.summary.detection': 'Deteksi: {value}',
    'bank.detail.summary.parse': 'Parsing: {value}',
    'bank.detail.summary.rows': 'Baris: {value}',
    'bank.detail.summary.warnings': 'Peringatan: {value}',
    'bank.detail.summary.errors': 'Kesalahan: {value}',
    'bank.recognition.status.pending': 'Dalam antrean',
    'bank.recognition.status.processing': 'Membaca dokumen…',
    'bank.recognition.status.needsReview': 'Perlu diperiksa',
    'bank.recognition.status.confirmed': 'Dikonfirmasi',
    'bank.recognition.status.rejected': 'Ditolak',
    'bank.recognition.status.failed': 'Kesalahan',
    'bank.recognition.next.pending': 'Dokumen menunggu diproses. Halaman ini dapat tetap terbuka.',
    'bank.recognition.next.processing': 'Mengekstrak transaksi dari file. Proses ini dapat memakan waktu beberapa menit.',
    'bank.recognition.next.needsReview': 'Bandingkan transaksi yang ditemukan dengan dokumen asli dan perbaiki kesalahan.',
    'bank.recognition.next.confirmed': 'Transaksi telah dibuat dan siap diproses lebih lanjut.',
    'bank.recognition.next.rejected': 'Dokumen ditolak. Unggah file yang diperbaiki jika masih diperlukan.',
    'bank.recognition.next.failed': 'Ulangi pengenalan. Jika masih gagal, unggah file lain.',
    'bank.recognition.bank': 'Bank: {bank}',
    'bank.recognition.operations': 'Transaksi ditemukan: {count}',
    'bank.detail.group.operations': 'Operasi',
    'bank.detail.group.problems': 'Masalah',
    'bank.detail.group.document': 'Dokumen',
    'bank.detail.group.advanced': 'Advanced',
    'bank.detail.tab.recognition': 'Pengenalan',
    'bank.detail.tab.transactions': 'Transaksi',
    'bank.detail.tab.quality': 'Laporan kualitas',
    'bank.detail.tab.duplicates': 'Duplikat',
    'bank.detail.tab.history': 'Riwayat',
    'bank.detail.tab.metadata': 'Metadata',
    'bank.detail.tab.reprocessPreview': 'Pratinjau reprocess',
    'bank.detail.table.counterparty': 'Rekanan',
    'bank.detail.table.purpose': 'Keterangan',
    'bank.detail.table.matching': 'Pencocokan',
    'bank.duplicate.currentOperation': 'Transaksi saat ini',
    'bank.duplicate.existingImport': 'Sebelumnya diimpor',
    'bank.duplicate.field.date': 'Tanggal: {value}',
    'bank.duplicate.field.amount': 'Jumlah:',
    'bank.duplicate.field.direction': 'Arah: {value}',
    'bank.duplicate.field.bankReference': 'Referensi bank: {value}',
    'bank.duplicate.field.customerReference': 'Referensi pelanggan: {value}',
    'bank.duplicate.field.counterparty': 'Rekanan: {value}',
    'bank.duplicate.field.description': 'Deskripsi: {value}',
    'bank.duplicate.field.import': 'Impor:',
    'bank.duplicate.field.bank': 'Bank: {value}',
    'bank.duplicate.field.account': 'Rekening: {value}',
    'bank.duplicate.confirm': 'Konfirmasi duplikat',
    'bank.duplicate.dismiss': 'Bukan duplikat',
    'bank.duplicates.title': 'Kemungkinan duplikat',
    'bank.duplicates.subtitle': 'Sistem menemukan transaksi yang mirip dengan yang sudah diimpor. Konfirmasi duplikat jika ini unggahan ulang transaksi yang sama, atau tolak jika ini transaksi terpisah.',
    'bank.duplicates.empty.title': 'Duplikat tidak ditemukan',
    'bank.duplicates.empty.description': 'Tidak ada transaksi serupa dari unggahan sebelumnya untuk impor ini.',
    'bank.quality.title': 'Kualitas impor',
    'bank.quality.subtitle': 'Menunjukkan apakah pengenalan file dapat dipercaya sebelum matching dan alokasi.',
    'bank.quality.metric.bank': 'Bank',
    'bank.quality.metric.format': 'Format',
    'bank.quality.metric.detectionConfidence': 'Keyakinan deteksi',
    'bank.quality.metric.parseConfidence': 'Keyakinan parsing',
    'bank.quality.metric.rows': 'Baris',
    'bank.quality.metric.parsed': 'Dikenali',
    'bank.quality.metric.skipped': 'Dilewati',
    'bank.quality.metric.duplicates': 'Duplikat',
    'bank.quality.desc.rawQualityStatus': 'Status kualitas mentah: {status}',
    'bank.quality.desc.detectionConfidence': 'Keyakinan deteksi bank/format',
    'bank.quality.desc.parseConfidence': 'Kualitas parsing baris file',
    'bank.quality.desc.totalRows': 'Total baris transaksi',
    'bank.quality.desc.parsedTransactions': 'Transaksi bank yang dibuat',
    'bank.quality.desc.skippedRows': 'Baris tidak masuk impor',
    'bank.quality.desc.duplicateCandidates': 'Kemungkinan impor ulang',
    'bank.quality.balance.title': 'Pemeriksaan saldo',
    'bank.quality.balance.subtitle': 'Digunakan jika bank memberikan saldo awal/akhir atau running balance.',
    'bank.quality.balance.unavailable': 'Tidak tersedia',
    'bank.quality.balance.matches': 'Saldo cocok',
    'bank.quality.balance.mismatch': 'Saldo tidak cocok',
    'bank.quality.balance.mismatchMessage': 'Ada selisih saldo (informasi). Rekening koran bank adalah sumber kebenaran; posting tidak diblokir.',
    'bank.quality.balance.reviewRequired': 'Saldo rekening koran tidak cocok dengan perhitungan ulang. Hanya peringatan informasi — posting ke Syrve tidak diblokir.',
    'bank.quality.balance.confirmReview': 'Konfirmasi pemeriksaan saldo',
    'bank.quality.balance.override': 'Override: {reason}',
    'bank.quality.balance.openingBalance': 'Saldo awal',
    'bank.quality.balance.closingBalance': 'Saldo akhir',
    'bank.quality.balance.calculatedClosingBalance': 'Saldo akhir terhitung',
    'bank.quality.table.indicator': 'Indikator',
    'bank.quality.table.value': 'Nilai',
    'bank.quality.table.line': 'Baris',
    'bank.quality.table.type': 'Jenis',
    'bank.quality.table.message': 'Pesan',
    'bank.quality.table.whatToCheck': 'Yang perlu diperiksa',
    'bank.quality.table.nextAction': 'Tindakan berikutnya',
    'bank.quality.warnings.title': 'Peringatan',
    'bank.quality.warnings.subtitle': 'Impor berhasil. Periksa item di bawah — bukan error jika transaksi terlihat benar.',
    'bank.quality.warnings.empty': 'Tidak ada peringatan',
    'bank.quality.issue.line': 'Baris file {line}',
    'bank.quality.issue.snippetLabel': 'Teks di rekening koran',
    'bank.quality.issue.openTransaction': 'Buka transaksi',
    'bank.quality.issue.openTransactionHint': 'Buka tab Transaksi untuk menemukan baris ini.',
    'bank.quality.errors.title': 'Kesalahan',
    'bank.quality.errors.subtitle': 'Kesalahan berarti sebagian baris tidak dikenali atau impor perlu ditinjau.',
    'bank.quality.errors.empty': 'Tidak ada kesalahan',
    'bank.history.loading': 'Memuat riwayat impor…',
    'bank.history.error': 'Gagal memuat riwayat impor',
    'bank.history.title': 'Riwayat impor',
    'bank.history.subtitle': 'Peristiwa unggahan, deteksi, dan tindakan operator utama untuk rekening koran ini.',
    'bank.history.empty.title': 'Riwayat kosong',
    'bank.history.empty.description': 'Belum ada peristiwa terdaftar untuk impor ini.',
    'bank.history.table.datetime': 'Tanggal dan waktu',
    'bank.history.table.user': 'Pengguna',
    'bank.history.table.action': 'Tindakan',
    'bank.history.table.result': 'Hasil / pesan',
    'bank.history.detail.file': 'File: {fileName}',
    'bank.history.detail.candidates': 'Kandidat: {count}',
    'bank.history.detail.status': 'Status: {status}',
    'bank.history.detail.transactions': 'Transaksi: {count}',
    'bank.reprocess.status.completed': 'Selesai',
    'bank.reprocess.status.failed': 'Gagal',
    'bank.reprocess.status.fileUnavailable': 'File tidak tersedia',
    'bank.reprocess.previewTitle': 'Pratinjau dari {date}',
    'bank.reprocess.previewSubtitle': 'Perbandingan read-only pipeline saat ini dengan transaksi impor tersimpan.',
    'bank.reprocess.fileUnavailableMessage': 'File rekening koran asli tidak tersedia. Unggah file melalui impor biasa untuk memproses ulang.',
    'bank.reprocess.metric.adapter': 'Adapter',
    'bank.reprocess.metric.versions': 'Versi',
    'bank.reprocess.metric.confidence': 'Keyakinan',
    'bank.reprocess.metric.existingTransactions': 'Transaksi existing',
    'bank.reprocess.metric.previewTransactions': 'Transaksi pratinjau',
    'bank.reprocess.metric.added': 'Ditambahkan',
    'bank.reprocess.metric.removed': 'Dihapus',
    'bank.reprocess.metric.changed': 'Diubah',
    'bank.reprocess.metric.unchanged': 'Tidak berubah',
    'bank.reprocess.metric.warnings': 'Peringatan',
    'bank.reprocess.metric.errors': 'Kesalahan',
    'bank.reprocess.parserHint': 'parser {parser} · normalizer {normalizer}',
    'bank.reprocess.parseHint': 'parse {value}',
    'bank.reprocess.tab.title': 'Pratinjau reprocess',
    'bank.reprocess.tab.subtitle': 'Menjalankan proses read-only pipeline adapter saat ini pada file asli dan menyimpan diff. Data produksi tidak berubah.',
    'bank.reprocess.tab.runButton': 'Pratinjau reprocess',
    'bank.reprocess.tab.error': 'Gagal menjalankan pratinjau reprocess',
    'bank.reprocess.tab.empty.title': 'Pratinjau belum dijalankan',
    'bank.reprocess.tab.empty.description': 'Klik "Pratinjau reprocess" untuk membandingkan pipeline saat ini dengan transaksi tersimpan.',
    'bank.reprocess.tab.loading': 'Memuat pratinjau…',
    'bank.modal.balanceOverride.title': 'Konfirmasi pemeriksaan saldo',
    'bank.modal.balanceOverride.reason': 'Alasan',
    'bank.modal.balanceOverride.placeholder': 'Misalnya: sudah verifikasi total secara manual',
    'bank.modal.deleteImport.title': 'Hapus impor rekening koran',
    'bank.modal.deleteImport.description': 'Impor, transaksi, dan pencocokan rekanan untuk rekening koran ini akan dihapus permanen. Aturan pencocokan rekanan tetap disimpan.',
    'bank.modal.deleteImport.reason': 'Alasan',
    'bank.modal.deleteImport.placeholder': 'Misalnya: file salah, perlu impor ulang',
    'bank.modal.deleteImport.confirm': 'Hapus impor',
    'bank.detail.deleteImport': 'Hapus impor',
    'bank.detail.deleteImport.error': 'Gagal menghapus impor',
    'bank.adapters.loading': 'Memuat katalog adapter bank…',
    'bank.adapters.error.unavailable': 'Gagal memuat daftar bank yang didukung.',
    'bank.adapters.readonlyNotice': 'Adapter didefinisikan di kode dan tidak dapat diedit dari admin. Perubahan memerlukan rilis aplikasi.',
    'bank.adapters.empty': 'Belum ada adapter bank yang dipublikasikan.',
    'bank.adapters.table.bank': 'Bank',
    'bank.adapters.table.format': 'Format',
    'bank.adapters.table.status': 'Status',
    'bank.adapters.table.extensions': 'Ekstensi',
    'bank.adapters.table.capabilities': 'Kemampuan',
    'bank.adapters.table.adapter': 'Adapter',
    'bank.adapters.table.confidence': 'Keyakinan',
    'bank.adapters.table.examples': 'Contoh file',
    'bank.adapters.table.notes': 'Catatan',
    'bank.adapters.table.updated': 'Diperbarui',
  },
} as const;
